import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Footer from '../components/Footer';

// Siluetă de mașină, decorativă, în fundalul paginii - linie simplă, discretă.
function CarDecor() {
  return (
    <svg className="login-car-decor" viewBox="0 0 620 260" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M40 190 L70 140 Q90 110 130 108 L230 104 Q260 104 280 82 Q300 60 340 58 L470 56
               Q500 56 520 78 L560 122 Q590 128 600 150 L600 190 Z"
        stroke="#bcd8f5" strokeWidth="3" />
      <circle cx="150" cy="196" r="34" stroke="#bcd8f5" strokeWidth="3" />
      <circle cx="470" cy="196" r="34" stroke="#bcd8f5" strokeWidth="3" />
      <line x1="40" y1="190" x2="600" y2="190" stroke="#bcd8f5" strokeWidth="3" />
    </svg>
  );
}

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [remember, setRemember] = useState(!!localStorage.getItem('rememberedUser'));
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const saved = localStorage.getItem('rememberedUser');
    if (saved) setForm(f => ({ ...f, username: saved }));
  }, []);

  // Countdown timer la eroare
  useEffect(() => {
    if (countdown === null) return;
    if (countdown === 0) { setError(''); setCountdown(null); return; }
    const t = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await api.post('/api/auth/login', form);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('refreshToken', res.data.refreshToken);
      localStorage.setItem('username', res.data.username);
      localStorage.setItem('isAdmin', res.data.isAdmin);
      localStorage.setItem('rol', res.data.rol || 'Level_0');
      localStorage.setItem('vehiculAsignat', res.data.vehiculAsignat || '');
      if (remember) localStorage.setItem('rememberedUser', form.username);
      else localStorage.removeItem('rememberedUser');
      navigate('/', { replace: true });
    } catch (err) {
      const msg = err.response?.data?.error || 'Eroare la autentificare';
      setError(msg);
      setCountdown(3);
    } finally {
      setLoading(false);
    }
  };

  const loginDemo = async () => {
    setError(''); setLoading(true);
    try {
      const res = await api.post('/api/auth/login', { username: 'demo', password: 'demo' });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('refreshToken', res.data.refreshToken);
      localStorage.setItem('username', 'demo');
      localStorage.setItem('isAdmin', res.data.isAdmin);
      localStorage.setItem('rol', res.data.rol || 'Level_0');
      localStorage.setItem('vehiculAsignat', res.data.vehiculAsignat || '');
      navigate('/', { replace: true });
    } catch (err) {
      setError('Contul demo nu este disponibil momentan');
      setCountdown(3);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-with-footer">
      <div className="page-body">
        <div className="login-page">
          <CarDecor />

          <div className="login-top-bar">
            <div className="login-brand-header">
              <div className="login-brand-icon"><img src="/logo.png" alt="" /></div>
              <div>
                <div className="login-brand-name">Software Consulting SRL</div>
                <div className="login-brand-cui">CUI: 48478205</div>
              </div>
            </div>
          </div>

          <div className="login-content-grid">

          {/* ---- Coloana stânga: prezentare (centrată vertical) ---- */}
          <div className="login-col login-col-side">
            <div className="login-features-wrap">
              <div className="login-feature-row">
                <div className="login-feature-icon" style={{background:'#1fae6b'}}>🛡️</div>
                <div>
                  <div className="login-feature-title">Te ajută să fii mereu pregătit</div>
                  <div className="login-feature-desc">Urmărește ușor istoricul, termenele și documentele fiecărui vehicul.</div>
                </div>
              </div>
              <div className="login-feature-row">
                <div className="login-feature-icon" style={{background:'#2d8fe0'}}>🚗</div>
                <div>
                  <div className="login-feature-title">Reduce timpul de lucru</div>
                  <div className="login-feature-desc">Procese mai rapide, mai puține erori, mai mult timp pentru clienți.</div>
                </div>
              </div>
              <div className="login-feature-row">
                <div className="login-feature-icon" style={{background:'#7c5cd6'}}>📈</div>
                <div>
                  <div className="login-feature-title">Crește eficiența afacerii tale</div>
                  <div className="login-feature-desc">Date centralizate, rapoarte clare, control total.</div>
                </div>
              </div>

              <div className="login-feature-row">
                <div className="login-feature-icon" style={{background:'#e0912d'}}>🛞</div>
                <div>
                  <div className="login-feature-title">Istoric Service &amp; Vulcanizare</div>
                </div>
              </div>
            </div>
          </div>

          {/* ---- Coloana centru: titlu + formularul de login ---- */}
          <div className="login-col">
            <p className="login-center-welcome">Bine ați venit în</p>
            <h1 className="login-center-title">Monitorizare Flotă</h1>
            <p className="login-center-sub">
              Gestionare simplă și eficientă pentru afacerea dumneavoastră auto.
            </p>
            <div className="login-box">
              <div className="login-logo">
                <div className="login-logo-icon"><img src="/logo.png" alt="Monitorizare Flotă" /></div>
                <h2>Monitorizare Flotă</h2>
                <p>Gestionare parc auto</p>
              </div>

              {error && (
                <div className="login-error">
                  {error}
                  {countdown > 0 && (
                    <span style={{marginLeft:8,fontWeight:'bold'}}>({countdown}s)</span>
                  )}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>✉️ Utilizator sau Email</label>
                  <input type="text" value={form.username}
                    onChange={e => setForm({...form, username: e.target.value})}
                    autoFocus required />
                </div>
                <div className="form-group" style={{position:'relative'}}>
                  <label>🔒 Parolă</label>
                  <input type={showPass?'text':'password'} value={form.password}
                    onChange={e => setForm({...form, password: e.target.value})}
                    required style={{paddingRight:36, width:'100%'}} />
                  <button type="button" onClick={() => setShowPass(!showPass)}
                    style={{position:'absolute',right:8,bottom:8,background:'none',border:'none',cursor:'pointer',fontSize:16,color:'#888'}}>
                    {showPass ? '🙈' : '👁️'}
                  </button>
                </div>
                <div className="login-remember-row">
                  <label htmlFor="remember">
                    <input type="checkbox" id="remember" checked={remember} onChange={e=>setRemember(e.target.checked)} />
                    Ține minte utilizatorul
                  </label>
                  <a href="/uitat-parola" className="login-forgot-link">Ai uitat parola?</a>
                </div>
                <button className="login-submit" type="submit" disabled={loading || countdown > 0}>
                  {loading ? 'Se conectează...' : countdown > 0 ? `Reîncearcă în ${countdown}s` : <>🔑 Conectare</>}
                </button>
              </form>

              <button className="login-submit login-submit-demo" type="button" onClick={loginDemo}
                disabled={loading || countdown > 0} style={{marginTop:10}}>
                🎯 Intră Demo
              </button>

              <div className="login-signup-row">
                Încă nu ai cont? <a href="/inregistrare">Înregistrează-te aici</a>
              </div>

              <div className="login-secure-row">🔒 Conținut securizat</div>
              <div className="login-help-link"><a href="/help">❓ Cum se folosește</a></div>
            </div>
          </div>

          {/* ---- Coloana dreapta: beneficii + automatizare ---- */}
          <div className="login-col login-col-side">
            <div className="login-perk-card">
              <div className="login-perk-icon">🛡️</div>
              <div>
                <div className="login-perk-title">Monitorizare Documente &amp; Zero Amenzi</div>
                <div className="login-perk-desc">Asigurări auto: RCA &amp; CASCO</div>
              </div>
            </div>
            <div className="login-perk-card">
              <div className="login-perk-icon">📄</div>
              <div>
                <div className="login-perk-title">Taxe și verificări obligatorii</div>
                <div className="login-perk-desc">ITP &amp; Rovinietă</div>
              </div>
            </div>
            <div className="login-perk-card">
              <div className="login-perk-icon">🚚</div>
              <div>
                <div className="login-perk-title">Personal: Vizite medicale și documente șoferi</div>
                <div className="login-perk-desc">Vizite medicale, ADR, CPC, tahograf</div>
              </div>
            </div>
            <div className="login-perk-card">
              <div className="login-perk-icon">📦</div>
              <div>
                <div className="login-perk-title">Transport și logistică</div>
                <div className="login-perk-desc">Copii conforme, Licențe, Asistență rutieră</div>
              </div>
            </div>

            <div className="login-automation">
              <div className="login-automation-text">Automatizare inteligentă<br/>pe Telegram &amp; Email</div>
              <div className="login-automation-icons">
                <span>✈️</span>
                <span>✉️</span>
              </div>
            </div>
          </div>

          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
